import React, { useContext, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import DragIndicatorIcon from 'assets/images/Category/DragIndicatorIcon.png';
import CheckBoxInput from 'components/common/Input/CheckBoxInput';
import CaretUpIcon from 'assets/images/Category/CaretUp.png';
import CaretDownIcon from 'assets/images/Category/CaretDown.png';
import EditUnderlineIcon from 'assets/images/Category/editUnderlineIcon.png';
import AddServiceIcon from 'assets/images/Category/AddServiceIcon.png';
import DescriptionIcon from 'assets/images/Category/DescriptionIcon.png';
import DeleteIcon from 'assets/images/Category/DeleteIcon.png';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormattedMessage } from 'react-intl';
import CustomPopover from 'components/common/CustomPopover';
import SubServiceList from './SubServiceList';
import { useNavigate } from 'react-router-dom';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';
import {
  providerAdminEditService,
  providerAdminViewService,
} from 'routes/AppUrls';
import { LocaleContext } from 'routes/Router';
import { useDispatch } from 'react-redux';
import {
  basicDetailsCallApi,
  SUB_SERVICE_DETAILS,
} from 'store/SuperAdmin/basicDetails/action';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const ServiceList = ({
  services,
  onEdit,
  onCheckBoxEnableDisable,
  onDelete,
  onDeleteSubService,
  onAddService,
  onReadOnly,
  onView,
  loading,
  onReorder,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [expanded, setExpanded] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [];

  if (onReadOnly) {
    PopoverData.push({
      label: <FormattedMessage id="View Sub-Category" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onView(viewData),
    });
  } else {
    PopoverData.push({
      label: <FormattedMessage id="Add Service" />,
      icon: <Image src={AddServiceIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onAddService(viewData),
    });

    PopoverData.push({
      label: <FormattedMessage id="Edit Sub-Category" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onEdit(viewData),
    });

    PopoverData.push({
      label: <FormattedMessage id="Delete" />,
      icon: <Image src={DeleteIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onDelete(viewData),
    });
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleEditSubService = (data) => {
    dispatch(basicDetailsCallApi(SUB_SERVICE_DETAILS, data));
    navigate(providerAdminEditService(locale, data.id));
  };

  const handleViewSubService = (data) => {
    dispatch(basicDetailsCallApi(SUB_SERVICE_DETAILS, data));
    navigate(providerAdminViewService(locale, data.id));
  };

  const handleDeleteSubService = (data) => {
    onDeleteSubService(data);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(services);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    onReorder && onReorder(items);
  };

  return (
    <Row className="m-0 p-0 mt-3">
      {loading ? (
        <>
          {[1, 2, 3, 4].map((item) => (
            <Row key={item} className="m-0 p-0 items-center border-b py-4">
              <Col md={6}>
                <div className="flex items-center gap-2">
                  <ShimmerBox width="32px" height="32px" />
                  <ShimmerBox width="32px" height="32px" />
                  <ShimmerBox width="200px" height="16px" />
                </div>
              </Col>
              <Col md={3}></Col>
              <Col md={3}>
                <div className="flex justify-end">
                  <ShimmerBox width="24px" height="24px" />
                </div>
              </Col>
            </Row>
          ))}
        </>
      ) : services?.length > 0 ? (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="services">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {services.map((service, index) => (
                  <Draggable
                    key={service.id}
                    draggableId={service.id.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} {...provided.draggableProps}>
                        <Row
                          className={`m-0 p-0 items-center ${
                            services?.length === index + 1
                              ? 'pt-4 pb-4'
                              : 'border-b py-4'
                          }`}
                        >
                          {onEdit ? (
                            <Col md={6} className={`items-center`}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={DragIndicatorIcon}
                                  alt={'icon'}
                                  {...provided.dragHandleProps}
                                  style={{
                                    height: '32px',
                                    width: '32px',
                                    cursor: 'grab',
                                  }}
                                />
                                <CheckBoxInput
                                  height={'32px'}
                                  onChange={() =>
                                    onCheckBoxEnableDisable(service)
                                  }
                                  checked={
                                    service?.provider_product_admin &&
                                    service?.is_public
                                  }
                                />
                                {service?.child?.length > 0 && (
                                  <button
                                    className="expand-btn text-lg"
                                    onClick={() => toggleExpand(service.id)}
                                    aria-label={`Toggle sub-services for ${service.name}`}
                                  >
                                    {expanded[service.id] ? (
                                      <img
                                        src={CaretUpIcon}
                                        alt={'icon'}
                                        style={{
                                          height: '24px',
                                          width: '24px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={CaretDownIcon}
                                        alt={'icon'}
                                        style={{
                                          height: '24px',
                                          width: '24px',
                                        }}
                                      />
                                    )}
                                  </button>
                                )}
                                <span className="service-name font-bold">
                                  {service.product_name}
                                </span>
                              </div>
                            </Col>
                          ) : (
                            <Col md={6} className="items-center">
                              <p className="service-name font-bold">
                                {service.title}
                              </p>
                            </Col>
                          )}

                          <Col md={3}>
                            {/* <div className="flex items-center gap-5">
              <span className="service-price text-gray-600">
                {service.price} SAR
              </span>
              <span className="service-time text-gray-600">
                {service.time_required_in_mints} min
              </span>
            </div> */}
                          </Col>

                          {onEdit ? (
                            <Col md={3} className="">
                              <Stack
                                direction="horizontal"
                                gap={4}
                                className="items-center justify-end"
                              >
                                {service?.provider_product_admin && (
                                  <div>
                                    <MoreVertIcon
                                      aria-describedby={id}
                                      style={{
                                        fill: '#3C1053',
                                        cursor: 'pointer',
                                      }}
                                      onClick={(e) =>
                                        handlePopoverClick(e, service)
                                      }
                                    />
                                    <CustomPopover
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl}
                                      handleClose={handlePopoverClose}
                                      options={PopoverData}
                                    />
                                  </div>
                                )}
                              </Stack>
                            </Col>
                          ) : (
                            <Col md={3} className="text-end">
                              {service?.sub_services?.length > 0 && (
                                <button
                                  className="expand-btn text-lg"
                                  onClick={() => toggleExpand(service.id)}
                                  aria-label={`Toggle sub-services for ${service.name}`}
                                >
                                  {expanded[service.id] ? (
                                    <img
                                      src={CaretUpIcon}
                                      alt={'icon'}
                                      style={{ height: '24px', width: '24px' }}
                                    />
                                  ) : (
                                    <img
                                      src={CaretDownIcon}
                                      alt={'icon'}
                                      style={{ height: '24px', width: '24px' }}
                                    />
                                  )}
                                </button>
                              )}
                            </Col>
                          )}

                          <Row className="m-0 p-0">
                            {expanded[service.id] &&
                              service?.child?.length > 0 && (
                                <div className="">
                                  <SubServiceList
                                    services={service.child}
                                    loading={loading}
                                    onEdit={(data) =>
                                      handleEditSubService(data)
                                    }
                                    onCheckBoxEnableDisable={
                                      onCheckBoxEnableDisable
                                    }
                                    onDelete={(data) =>
                                      handleDeleteSubService(data)
                                    }
                                    onReadOnly={onReadOnly}
                                    onView={(data) =>
                                      handleViewSubService(data)
                                    }
                                  />
                                </div>
                              )}
                          </Row>
                        </Row>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : null}
    </Row>
  );
};

export default ServiceList;
